import {Queries} from '../../api/queries';
import TagName from './TagName';
import {Box, Checkbox} from '@sproutsocial/racine';
import {useQuery} from '@tanstack/react-query';
import {type SyntheticEvent, useCallback} from 'react';

interface TagPickerProps {
	/**
	 * Tags that should be checked, not indeterminate tags
	 */
	selectedTagIds: Set<string>;
	/**
	 * Tags that are indeterminate, not checked tags
	 */
	indeterminateTagIds?: Set<string>;
	onTagDeselected: (tagId: string) => void;
	onTagSelected: (tagId: string) => void;
}

const TagPicker = (props: TagPickerProps) => {
	const {data: tags} = useQuery(Queries.tags());

	const {selectedTagIds, indeterminateTagIds, onTagDeselected, onTagSelected} = props;

	const onCheckboxChange = useCallback(
		(event: SyntheticEvent<HTMLInputElement>) => {
			const tagId = event.currentTarget.value;

			if (selectedTagIds.has(tagId)) {
				onTagDeselected(tagId);
			} else {
				onTagSelected(tagId);
			}
		},
		[selectedTagIds, onTagSelected, onTagDeselected],
	);

	return (
		<Box display='flex' flexDirection='column'>
			{tags?.map((tag) => (
				<Box key={tag.id} display='flex' alignItems='center' mb='space.200'>
					<Checkbox
						id={`checkbox-${tag.id}`}
						checked={selectedTagIds.has(tag.id) || indeterminateTagIds?.has(tag.id)}
						indeterminate={indeterminateTagIds?.has(tag.id)}
						value={String(tag.id)}
						onChange={onCheckboxChange}
						mr='space.300'
					/>

					<TagName id={tag.id} includeParents showIcon />
				</Box>
			))}
		</Box>
	);
};

export default TagPicker;
